export default __webpack_public_path__ + "static/media/G0330.34I-26141_-16016_0.1666258320000.9e9ecdc3.jpg";